<template>
  <div class="form-group">
    <label for="inputFeed">Anbieter auswählen</label>
    <select
      id="inputFeed"
      class="custom-select"
      aria-label="Anbieter auswählen"
      v-model="selected"
      required
      @change="changed($event.target.value)"
    >
      <optgroup class="text-muted bg-light" label="Anbieter">
        <option v-for="(item, index) in provider" :key="index" :value="index">{{item.name}} ({{item.category}})</option>
      </optgroup>
    </select>
  </div>
</template>

<script>
export default {
  name: "User.Menu.SelectFeed",
  data: function() {
    return {
      selected: ""
    };
  },
  computed: {
    provider() {
      let provider = [];
      this.$store.state.UserFeeds.items.forEach((element, indexCategory) => {
        element.urls.forEach((feed, indexFeed) => {

          let feedType = 1;
          if (feed.type !== undefined )
            feedType = feed.type;

            let feedData = {};
          if (feed.data !== undefined )
            feedData = feed.data;

          provider.push({
            indexCategory: indexCategory,
            indexFeed: indexFeed,
            id: feed.id,
            type: feedType,
            name: feed.name,
            url: feed.url,
            data: feedData,
            category: element.name,
            categoryId: element.id
          });
        });
      });
      return provider;
    }
  },
  methods: {
    changed: function(index) {
      //console.log(this.provider[index]);
      this.$emit("changed", this.provider[index]);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
